export default __webpack_public_path__ + "static/media/menuBar-white.d24a438a.svg";